﻿import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { BookDemoContext } from './components/BookDemoContext'
import BookDemoModal from './components/BookDemoModal'
import HomePage from './pages/HomePage'
import ProductTour from './pages/ProductTour'
import HowItWorks from './pages/HowItWorks'
import LegalPage from './pages/LegalPage'

function AppRedirect() {
  const location = useLocation()
  const appUrl = import.meta.env.VITE_SMARTHIRE_APP_URL || 'http://localhost:3000'
  window.location.replace(`${appUrl}${location.pathname}${location.search}`)
  return null
}

function ScrollToTop() {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [location.pathname])

  return null
}

export default function App() {
  const [showDemo, setShowDemo] = useState(false)
  const [demoSource, setDemoSource] = useState('')
  const openDemo = (source = 'Book a Demo') => { setDemoSource(source); setShowDemo(true) }
  return (
    <BookDemoContext.Provider value={openDemo}>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/product-tour" element={<ProductTour />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/terms" element={<LegalPage pageKey="terms" />} />
          <Route path="/privacy" element={<LegalPage pageKey="privacy" />} />
          <Route path="/security" element={<LegalPage pageKey="security" />} />
          <Route path="/cookies" element={<LegalPage pageKey="cookies" />} />
          <Route path="/accessibility" element={<LegalPage pageKey="accessibility" />} />
          <Route path="/contact" element={<LegalPage pageKey="contact" />} />
          <Route path="*" element={<AppRedirect />} />
        </Routes>
      </BrowserRouter>
      {showDemo && <BookDemoModal source={demoSource} onClose={() => setShowDemo(false)} />}
    </BookDemoContext.Provider>
  )
}
